import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import { Table, Form } from 'react-bootstrap';
import { withRouter} from 'react-router-dom';
import { Col } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from 'jspdf'
import 'jspdf-autotable'

import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
import mixin from '../../../utils/mixin';
import consts from "../../../utils/constants";

import { DeckGL } from '@deck.gl/react';
import {PolygonLayer} from '@deck.gl/layers';

import {StaticMap, MapContext, NavigationControl} from 'react-map-gl';
import {MapboxLayer} from '@deck.gl/mapbox';

import { 
  getHeatMapByDevelopment,
  getUsersByDevelopment,
  getTowersByDevelopment,
  getStoriesByDevelopment
} from '../../../api/Api.js';

import NavbarMenu from '../NavbarMenu/NavbarMenu.js';

import './Reports.scss';

const {methods} = mixin;

registerLocale('es', es);

const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
  <input type="text" className="form-control" value={value} onClick={onClick} ref={ref} />
));

const MAPBOX_TOKEN = process.env.REACT_APP_MAP_BOX_TOKEN;

const NAV_CONTROL_STYLE = {
  position: 'absolute',
  top: 10,
  left: 10
};

const HEAT_COLORS = [
    [52,152,219], 
    [41,128,185], //[26,188,156], 
    [22,160,133],
    [39,174,96],
    [46,204,113],
    [241,196,15],
    [243,156,18],
    [230,126,34],
    [211,84,0],
    [192,57,43]
];

const MAX_PITCH = 90;
const INITIAL_PITCH = 45;

class HeatMap extends Component {

  constructor(props){
    
    super(props);

    let dev = localStorage.getItem('dev');
    if(dev == null || dev == undefined || dev == ''){
      this.props.history.push("/admin");
      window.location.reload();
    }

    dev = JSON.parse(dev);
    
    let token = localStorage.getItem('jwt');

    if(token){
      const decoded = jwt_decode(token);
      let date = new Date(decoded.exp * 1000);
      let mydate = new Date();
      
      if (date <= mydate) {
        this.logout();
      }
    }else{
      this.logout();
    }

    methods.G_changeLanguage('es');

    this.tooltipRef = React.createRef();

    this.state = {
      loading: false,
      loading_users: false,
      loading_info: false,
      lots: [],
      towers: [],
      stories: [],
      separators: [],
      users: [],
      agents: [],
      items: [],
      max_views: 0,
      development_id:  dev.development_id,
      development: dev,
      startDate: new Date(),
      endDate: new Date(),
      selectedUser: '',
      selectedAgent: '',
      selectedType: '',
      hoverInfo : null,
      gl: null,
      isHovering: false,
      show2D: false,
      showSatelliteMap: false,
      polygonExtruded: true,
      deckGLPitch: INITIAL_PITCH,
      deckGLInitialState: {
        longitude: dev.longitude,
        latitude: dev.latitude,
        zoom: dev.zoom,
        maxZoom: dev.max_zoom,
        minZoom: dev.min_zoom,
        pitch: INITIAL_PITCH,
        bearing: 0,
        maxPitch: MAX_PITCH,
        minPitch: 0
      }
    }
  }

  // DeckGL and mapbox will both draw into this WebGL context
  _onWebGLInitialized = (gl) => {
    this.setState({gl});
  }

  // Add deck layer to mapbox
  _onMapLoad = () => {
    const map = this._map;
    const deck = this._deck;
    map.addLayer(new MapboxLayer({id: 'my-scatterplot', deck}));
  }
  
  getPolygon(p){
    let c = p.coordinates.latlon;
    let res = [];
    c.forEach(i => {
      let lonlat = [i[1], i[0], this.getHeightOffset(p)];
      res.push(lonlat);
    });
    return [res]
  }

  getElevation(p){
    return parseFloat(p.height);
  }

  getFillColor(p){
    if(p.views == 0){
      return HEAT_COLORS[0];
    }
    if(p.views == this.state.max_views){
      return HEAT_COLORS[9];
    }
    let percentil = 0;
    percentil = Math.ceil(p.views * 10 / this.state.max_views);
    if(percentil > 0 && percentil <= 10){
      return HEAT_COLORS[percentil - 1];
    }
    if(percentil < 0){
      return HEAT_COLORS[0];
    }
    if(percentil > 10){
      return HEAT_COLORS[9];
    }
    return HEAT_COLORS[0]
  }

  onClick(info, event){
    return null;
  }

  onHover = (info) =>{
    this.setState({
      hoverInfo: info
    });
  }

  onDeckHover = (object) => {
    if(object.object && object.object.name){
      this.setState({
        isHovering: true
      });
    }else{
      this.setState({
        isHovering: false
      });
    }
  }

  getCursor = (action) => {
    const { hoverInfo, gl, isHovering } = this.state;
    
    if(isHovering){
      return 'pointer';
    }

    return action.isDragging ? 'grabbing' : 'grab';
  }

  getDeckGLState = () => {
    return this.state.deckGLInitialState;
  }

  showMap3D = () => {
    if(this.state.show2D){
      let deckState = {...this.state.deckGLInitialState, ...{pitch: INITIAL_PITCH, maxPitch: MAX_PITCH}};
      
      this.setState({
        show2D: false,
        polygonExtruded: true,
        deckGLInitialState: deckState
      })
    }else{
      let deckState = {...this.state.deckGLInitialState, ...{pitch: 0, maxPitch: 0}};
      
      this.setState({
        show2D: true,
        polygonExtruded: false,
        deckGLInitialState: deckState
      })
    }
  }

  showSatelliteMap = () => {
    this.setState({
      showSatelliteMap: !this.state.showSatelliteMap
    });
  }

  getMapViewStyle = () => {
    if(this.state.showSatelliteMap){
      return "mapbox://styles/mapbox/satellite-streets-v11";
    }
    return "mapbox://styles/mapbox/outdoors-v11";
  }

  getTootltipStyle = (hoverInfo) => {
    
    let tooltipW = 200;
    let tooltipH = 0;
    if(this.tooltipRef.current){
      tooltipW = this.tooltipRef.current.offsetWidth;
      tooltipH = this.tooltipRef.current.offsetHeight;

      let x_val = hoverInfo.x < this._deck.canvas.width / 2 ? hoverInfo.x + 10 : hoverInfo.x - tooltipW - 10;
      let y_val = hoverInfo.y < this._deck.canvas.height / 2 ? hoverInfo.y + 10 : hoverInfo.y - tooltipH - 10;

      return {pointerEvents: 'none', left: x_val, top: y_val};

    }

    return {pointerEvents: 'none', left: 0, top: 0}
    
  }

  logout = () => {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    localStorage.removeItem("developments");
    this.props.history.push("/admin/login");
    window.location.reload();
  }

  renderPrice = (object) => {
    if(object.price){
      if(object.discount && object.discount > 0){
        return(
          <p className="text-right">
            <b>Reserva con:</b> {methods.G_renderPrice(object.price, 'MXN')}<br/>
            <b>Descuento:</b> -{methods.G_renderPrice(object.discount,'MXN')}<br/>
            <b>Final:</b> {methods.G_renderPrice(object.price - object.discount, 'MXN')} <br/>
          </p>
        )
      }else{
        return(
          <p><b>Reserva con:</b> {methods.G_renderPrice(object.price, 'MXN')}</p>
        )
      }
    }
  }

  getSeparatorPolygon(p){
    let c = p.coordinates.latlon;
    let res = [];
    c.forEach(i => {
      let lonlat = [i[1], i[0], this.getSeparatorHeightOffset(p)];
      res.push(lonlat);
    });
    return [res]
  }

  getHeightOffset(p){
    if(this.state.development && this.state.development.is_vertical){
      if(p.story_number && p.story_number > 1){
        let stories_below = this.state.stories.filter(x => (x.tower_id == p.tower_id && x.number < p.story_number));
        if(stories_below.length > 0){
          let count_separators = stories_below.length;
          let offset = 0;
          stories_below.forEach(i => {
            offset += i.height;
          });
          return offset + (count_separators * 0.1);
        }
      }
    }

    return 0;
  }

  getSeparatorHeightOffset(p){
    if(this.state.development && this.state.development.is_vertical){
      if(p.story_number && p.story_number > 1){
        let stories_below = this.state.stories.filter(x => (x.tower_id == p.tower_id && x.number < p.story_number));
        if(stories_below.length > 0){
          let count_separators = stories_below.length - 1;
          let offset = 0;
          stories_below.forEach(i => {
            offset += i.height;
          });
          return offset + (count_separators * 0.1);
        }
      }
    }

    return 0;
  }

  hideUpperStories(p){
    let lot = p && p.object ? p.object : null;

    if(this.state.development && this.state.development.is_vertical && lot){
      
      this.state.lots.map((x) => {
        x.enabled = true;
        if(x.tower_id == lot.tower_id && x.story_number > lot.story_number){
          x.enabled = false;
        }
      });

      this.state.separators.map((x) => {
        x.enabled = true;
        if(x.tower_id == lot.tower_id && x.story_number > lot.story_number){
          x.enabled = false;
        }
      });

    }

  }

  enableAllLots(){
    this.state.lots.map((x) => {
      x.enabled = true;
    });
    this.state.separators.map((x) => {
      x.enabled = true;
    });
  }

  getVisibleLots(){
    return this.state.lots.filter(x => x.enabled);
  }

  getVisibleSeparators(){
    return this.state.separators.filter(x => x.enabled);
  }

  getSeparators(lots){
    let separators = lots.map((x) => {
      return {
        height: 0.1,
        tower_id: x.tower_id,
        story_id: x.story_id,
        story_number: x.story_number,
        coordinates: x.coordinates,
        enabled: x.enabled,
      }
    })

    return separators;
  }

  dispatchActivity = () => new Promise((resolve, reject) => {
    // const { developmentId } = this.state
    let startD = this.state.startDate;
    startD = startD.setHours(0, 0, 0, 0);
    
    let endD = this.state.endDate;
    endD = endD.setHours(23, 59, 59, 999);

    let user_id = null;
    if(this.isUserSeller()){
        let user = localStorage.getItem('user');
        user = JSON.parse(user);
        user_id = user.user_id;
    }
    
    getHeatMapByDevelopment({
      development_id: this.state.development_id,
      since: startD,
      until: endD,
      user: user_id,
    }).then((res) => {
      let items = [];
      let towers = [];
      let stories = [];
      let max_views = 0;
      if (res && res.lots) {
        items = res.lots;
        max_views = res.max_views;
        towers = res.towers;
        stories = res.stories;
      }

      let separators = this.getSeparators(items);

      this.setState({
        lots: items,
        max_views: max_views,
        towers: towers,
        stories: stories,
        separators: separators,
      }, () => resolve('activity data ok'));
    });
  });

  dispatchUsers = () => {
    getUsersByDevelopment({
      development_id: this.state.development_id
    }).then((res) => {
      let users = [];
      let selectedUser = '';
      let agents = [];
      if (res) {
        if(this.isUserSeller()){
          let user = localStorage.getItem('user');
          user = JSON.parse(user);
          users = res.filter(x => x.user_id == user.user_id);
          selectedUser = 0;
          agents = this.getUserAgents(users[0]);
        }else{
          users = res;
        }
        
      }
      
      this.setState({
        users: users,
        agents: agents,
        selectedUser: selectedUser,
      });
    });
  }

  getUserAgents = (user) => {
    let agents = [];
    
    if(user && user.user_id){
      agents.push({
        agent_id: user.user_id,
        first_name: user.first_name,
        last_name: user.last_name,
        last_name_2: user.last_name_2,
        type: 'user',
        user_id: user.user_id,
        user_code: user.user_code
      });

      return agents.concat(user.agents);
    }

    return agents;
  }

  isUserSeller = () => {
    let user = localStorage.getItem('user');
    user = JSON.parse(user);
    return (consts.UserType.DEV_SELLER == user.type_id || consts.UserType.DEV_REAL_STATE == user.type_id);
  }

  applyFilters = (items) => {
    let tx = items ? items : [...this.state.lots];
    
    if(this.state.startDate && this.state.endDate){
      tx = tx.filter( x => {
        let tx_date = new Date(x.created_time);
        let startD = this.state.startDate;
        startD = startD.setHours(0, 0, 0, 0);
        let endD = this.state.endDate;
        endD = endD.setHours(23, 59, 59, 999);
        
        return tx_date.getTime() >= startD && tx_date.getTime() <= endD;
      });
    }

    if(this.state.selectedUser || this.state.selectedUser === 0){
      if(this.state.users && this.state.users.length > 0){
        let user = this.state.users[this.state.selectedUser];
        tx = tx.filter(x => x.seller_user_id == user.user_id);
      }
    }

    if(this.state.selectedAgent || this.state.selectedAgent === 0){
      let agent = this.state.agents[this.state.selectedAgent];
      if(agent.type == 'user'){
        tx = tx.filter(x => x.agent_id == null);
      }else{
        tx = tx.filter(x => x.agent_id == agent.agent_id);
      }
    }

    if(this.state.selectedType){
      tx = tx.filter(x => x.type == this.state.selectedType);
    }

    return tx;
  }

  filtersBtnClick = (e) => {
    e.preventDefault();
    this.sendReportRequest();
  }

  sendReportRequest = () => {
    this.setState({
        loading_info: true,
    });
    let startD = this.state.startDate;
    startD = startD.setHours(0, 0, 0, 0);
    
    let endD = this.state.endDate ? this.state.endDate : this.state.startDate;
    endD = endD.setHours(23, 59, 59, 999);

    let user_id = null;
    if(this.state.selectedUser || this.state.selectedUser === 0){
      if(this.state.users && this.state.users.length > 0){
        let user = this.state.users[this.state.selectedUser];
        user_id = user.user_id;
      }
    }
    
    let agent_id = null;
    
    if(this.state.selectedAgent || this.state.selectedAgent === 0){
      let agent = this.state.agents[this.state.selectedAgent];
      if(agent.type !== 'user'){
        agent_id = agent.agent_id
      }
    }
  
    let type = null;
    if(this.state.selectedType){
      type = this.state.selectedType;
    }

    const data = {
      development_id: this.state.development_id,
      since: startD,
      until: endD,
      user: user_id,
      agent: agent_id,
      type: type,
    }

    getHeatMapByDevelopment(data).then((res) => {
      let items = [];
      let max_views = 0;
      
      if (res && res.lots) {
        items = res.lots;
        max_views = res.max_views;
      }

      this.setState({
        lots: items,
        max_views: max_views,
        loading_info: false,
      });
    });
  }

  componentDidMount() {
    
    this.setState({
      loading: true
    }, () => {
      Promise.all([this.dispatchActivity()]).then(values => {
        
        this.setState({
            loading: false,
        });

      }, reason => {
          console.info(reason)
      });
    });

    this.dispatchUsers();
  }

  renderSimplePrice = (amount) => {
    if(amount){
      return(
        <span>{methods.G_renderPrice(amount, 'MXN')}</span>
      )
    }
    return(
      <span>{methods.G_renderPrice(0, 'MXN')}</span>
    )
  }

  renderType = (type) => {
    switch(type){
      case 'VIEW': return 'Vista';
      case 'RESERVATION_BUTTON': return 'Intento de Reservación';
      default: return '-';
    }
  }

  renderName = (a) => {
    let label = '';
    if(a){
      label = a.first_name ? a.first_name: '' ;
      label += a.last_name ? ' ' + a.last_name : '';
      label += a.last_name_2 ? ' ' + a.last_name_2 : '';
    }
    return label;
  }

  renderAgent = (i) => {
    if(i.agent_id && i.agent && i.agent.first_name){
      return this.renderName(i.agent);
    }
    return this.renderName(i.user);
  }

  renderTable = () => {
    let txs = (this.state.lots && this.state.lots.length > 0) ? [...this.state.lots] : [];

    const listTxs = txs ? txs.map((i) => {
      return( 
        <tr className="tx-item" key={i['_id']}>
          <td>{i.name}</td>
          <td>{i.views}</td>
          <td>{i.reservations}</td>
        </tr>
      )
    }) : [];

    if(listTxs.length > 0){
      return (
        <Table striped responsive bordered hover size="sm" id="tx_table">
          <thead>
            <tr>
              <th>Lote</th>
              <th>Vistas</th>
              <th>Reservaciones</th>
            </tr>
          </thead>
          <tbody>
            {listTxs}
          </tbody>
        </Table>
      );
    }else{
      return (
        <span>No hay actividad registrada en el período seleccionado.</span>
      );
    }

  }

  onDateChange = (dates) => {
    const [start, end] = dates;
    this.setState({
      startDate: start,
      endDate: end,
    });
  }

  onChangeUser = (e) => {
    const userIndex = e.target.value;
    const user = this.state.users[userIndex];
    this.setState({
      selectedUser: userIndex,
      agents: this.getUserAgents(user),
      selectedAgent: '',
    });
  }

  onChangeAgent = (e) => {
    this.setState({
      selectedAgent: e.target.value
    });
  }

  onChangeType = (e) => {
    this.setState({
      selectedType: e.target.value
    });
  }

  renderUserSelector = () => {
    let listUsers = [];
    if(this.state.users && this.state.users.length > 0){
      listUsers = this.state.users.map((a, i) => {
        let label = this.renderName(a);
        let k = a.user_id;
        if(a.real_state_name){
          label = a.real_state_name + ' / ' + label;
        }
        return (
          <option key={k} value={i}>{label}</option>
        );
      });
    }
    let options1 = <option value="">Todos</option>;
    if(this.isUserSeller()){
      options1 = null;
    }

    return (
      <select className="form-control" value={this.state.selectedUser} name='user_name' onChange={this.onChangeUser}>
        {options1}
        {listUsers}
      </select>
    );
  }

  renderAgentsSelector = () => {
    
    let listAgents = [];
    if(this.state.agents && this.state.agents.length > 0){
      listAgents = this.state.agents.map((a, i) => {
        let label = this.renderName(a);
        let k = a.agent_id; 
        let t = a.type
        return (
          <option key={t+'_'+k} value={i}>{label}</option>
        );
      });
    }

    return (
      <select className="form-control" value={this.state.selectedAgent} name='agent_name' onChange={this.onChangeAgent} >
        <option value="">Todos</option>
        {listAgents}
      </select>
    )
    
  }

  resetFilters = () => {
    this.setState({
      startDate: new Date(),
      endDate: new Date(),
      selectedUser: this.isUserSeller() ? 0 : '',      
      selectedAgent: '',
      selectedType: '',
    }, () => {
      this.sendReportRequest();
    });
    
  }

  getCSVData = () => {
    let csvData = [];

    csvData.push(['Fecha:', methods.G_simpleFormatDateOnly({date: this.state.startDate}) + ' - ' + methods.G_simpleFormatDateOnly({date: this.state.endDate})]);

    let userName = 'Todos';
    if(this.state.selectedUser){
      let user = this.state.users[this.state.selectedUser];
      userName = this.renderName(user);
    }
    csvData.push(['Usuario:', userName]);

    let agentName = 'Todos';
    if(this.state.selectedAgent){
      let agent = this.state.agents[this.state.selectedAgent];
      agentName = this.renderName(agent);
    }
    csvData.push(['Vendedor:', agentName]);

    /*let typeName = 'Todos';
    if(this.state.selectedType){
      switch(this.state.selectedType){
        case 'VIEW': typeName = 'Vista'; break;
        case 'RESERVATION_BUTTON': typeName = 'Intento de Reservación'; break;
        default: typeName = 'Todos'; break;
      }
    }
    csvData.push(['Tipo:', typeName]);
    */
    csvData.push([]);

    csvData.push([
      //'Fecha',
      'Lote',
      //'Tipo',
      'Vistas',
      'Intentos de Reservación'
    ]);

    if(this.state.lots && this.state.lots.length > 0){
      const listTxs = this.state.lots ? this.state.lots.map((i) => {
        return [
          //methods.G_simpleFormatDate({date: i.time_created + 'Z'}),
          i.name,
          i.views,
          i.reservations
        ];
      }) : [];

      if(listTxs){
        csvData = csvData.concat(listTxs)
      }
    }

    return csvData;
  }

  getFileName = () => {
    return 'Actividad_' + methods.G_simpleFormatDateOnly({date: new Date(), separator: '-'});
  }

  exportPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape"
    });
    doc.setFontSize(14);
    doc.text("Actividad", 15, 10);
    doc.setFontSize(10);
    let range = methods.G_simpleFormatDateOnly({date: this.state.startDate}) + ' - ' + methods.G_simpleFormatDateOnly({date: this.state.endDate});
    doc.text("Fecha: " + range, 15, 20);
    let userName = 'Todos';
    if(this.state.selectedUser){
      let user = this.state.users[this.state.selectedUser];
      userName = this.renderName(user);
    }
    doc.text("Usuario: " + userName, 15, 26);
    let agentName = 'Todos';
    if(this.state.selectedAgent){
      let agent = this.state.agents[this.state.selectedAgent];
      agentName = this.renderName(agent);
    }
    doc.text("Vendedor: " + agentName, 15, 32);
    
    /*let typeName = 'Todos';
    if(this.state.selectedType){
      switch(this.state.selectedType){
        case 'VIEW': typeName = 'Vista'; break;
        case 'RESERVATION_BUTTON': typeName = 'Intento de Reservación'; break;
        default: typeName = 'Todos'; break;
      }
    }
    doc.text("Tipo: " + typeName, 15, 38);*/
    
    if(this.state.lots.length > 0){
      doc.autoTable({ headStyles: { fillColor: [75, 92, 115] }, startY: 49, html: '#tx_table' })
    }else{
      doc.text("No hay actividad registrada en el período seleccionado.", 15, 49);
    }
    
    doc.save(this.getFileName() + ".pdf");
  }
  
  render() {
      const { lots, loading, hoverInfo, gl } = this.state;

      if (loading) {
        return (
          <div className="h-100">
            <NavbarMenu development={this.state.development} logout={this.logout} />
            <div className="container-fluid pt-4 h-100">
              Cargando...
            </div>
          </div>
        );
      }

      return (
        <div className="h-100">
          <NavbarMenu development={this.state.development} logout={this.logout} />
          <div className="container-fluid h-100 ext-container">
            <div className="row h-100">
              <div className="col-12 col-md-2 pt-4 pb-5 left-panel">
                <h4>Filtros</h4>
                <div className="row filter-row">
                  <Col xs="12">
                    <div className="form-group">
                      <label htmlFor="date_range_input">Fecha</label>
                      <DatePicker
                        id="date_range"
                        selected={this.state.startDate}
                        selectsRange
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        placeholderText='Selecccionar...'
                        dateFormat='dd/MM/yyyy'
                        onChange={this.onDateChange}
                        locale='es'
                        customInput={<CustomInput />}
                      />
                    </div>
                  </Col> 
                </div>
                <div className="row filter-row">
                  <Col xs="12">
                    <div className="form-group">
                      <label htmlFor="user_name">Inmobiliaria / Usuario</label>
                      {this.renderUserSelector()}
                    </div>
                  </Col> 
                </div>
                <div className="row filter-row">
                  <Col xs="12">
                    <div className="form-group">
                      <label htmlFor="agent_name">Vendedor</label>
                      {this.renderAgentsSelector()}
                    </div>
                  </Col> 
                </div>
                {false && <div className="row filter-row">
                  <Col xs="12">
                    <div className="form-group">
                      <label htmlFor="tx_type">Tipo</label>
                      <select className="form-control"  value={this.state.selectedType} name='tx_type' onChange={this.onChangeType}>
                        <option value="">Todos</option>
                        <option value="VIEW">Vista</option>
                        <option value="RESERVATION_BUTTON">Intento de Reservación</option>
                      </select>
                    </div>
                  </Col> 
                </div>}
                <div className="row filter-row">
                  <Col xs="12">
                    <div className="form-group text-right">
                      <button className="btn btn-cust-orange float-left" onClick={this.resetFilters.bind(this)}>Limpiar</button>
                      <button className="btn btn-cust-blue" onClick={this.filtersBtnClick.bind(this)} disabled={this.state.loading_info}>
                        {this.state.loading_info && (
                          <span className="spinner-border spinner-border-sm"></span>
                        )}
                        <span>Aplicar</span>
                      </button>
                    </div>
                  </Col> 
                </div>
              </div>

              <div className="col-12 col-md-10 right-panel deckgl-container map-container">
                <div className="switch-3D">
                    
                    <Form.Check 
                        type="switch"
                        id="map-view-switch"
                        label="3D"
                        checked={!this.state.show2D}
                        onChange={this.showMap3D}
                    />

                    <Form.Check 
                        type="switch"
                        id="map-view-switch-2"
                        label="Satélite"
                        checked={this.state.showSatelliteMap}
                        onChange={this.showSatelliteMap}
                    />
                    
                </div>
                <DeckGL
                    ref = {ref => {this._deck = ref && ref.deck; }}
                    initialViewState={this.getDeckGLState()}
                    controller={true}
                    onWebGLInitialized={this._onWebGLInitialized}
                    onHover= {object => this.onDeckHover(object)}
                    getCursor= {action => this.getCursor(action)}
                    ContextProvider={MapContext.Provider}
                >
                    <PolygonLayer 
                      id="polygon-layer"
                      data={this.getVisibleLots()} 
                      pickable= {true}
                      stroked= {true}
                      filled= {true}
                      wireframe= {true}
                      extruded= {this.state.polygonExtruded}
                      lineJointRounded= {true}
                      getPolygon= {d => this.getPolygon(d)}
                      getElevation= {d => this.getElevation(d)}
                      getFillColor= {d => this.getFillColor(d)}
                      getLineColor= {[0, 0, 0]}
                      getLineWidth= {1}
                      onClick= {(info, event) => this.onClick(info, event)}
                      onHover={info => this.onHover(info)}
                      material= {{
                          ambient: 0.5,
                          diffuse: 0.6,
                          shininess: 10,
                          specularColor: [30, 30, 30]
                      }}
                    />

                    {this.state.development && this.state.development.is_vertical &&
                      <PolygonLayer 
                        id="separator-layer"
                        data={this.getVisibleSeparators()} 
                        pickable= {true}
                        stroked= {true}
                        filled= {true}
                        wireframe= {true}
                        extruded= {this.state.polygonExtruded}
                        lineJointRounded= {true}
                        getPolygon= {d => this.getSeparatorPolygon(d)}
                        getElevation= {d => this.getElevation(d)}
                        getFillColor= {[0, 0, 0]}
                        getLineColor= {[0, 0, 0]}
                        getLineWidth= {1}
                        material= {{
                          ambient: 0.5,
                          diffuse: 0.6,
                          shininess: 10,
                          specularColor: [30, 30, 30]
                        }}
                      />
                    }
                    
                    {gl && (
                    <StaticMap
                        ref={ref => { this._map = ref && ref.getMap(); }}
                        gl={gl}
                        mapStyle={this.getMapViewStyle()} // mapbox://styles/mapbox/streets-v11, mapbox://styles/mapbox/outdoors-v11, mapbox://styles/mapbox/dark-v10, mapbox://styles/mapbox/satellite-v9
                        mapboxApiAccessToken={MAPBOX_TOKEN}
                        onLoad={this._onMapLoad}
                    />
                    )}
                    {gl && 
                    <NavigationControl style={NAV_CONTROL_STYLE} showCompass={false} />
                    }
                    
                    {hoverInfo && hoverInfo.object && (
                    <div ref={this.tooltipRef} id="tooltip" style={this.getTootltipStyle(hoverInfo)}>
                        <h5>{ hoverInfo.object.name }</h5>
                        <span>
                            <p>
                                <span><b>{hoverInfo.object.views}</b> Vistas<br/></span>
                                <span><b>{hoverInfo.object.reservations}</b> Int. de Reservación</span>
                            </p>
                        </span>
                    </div>
                    )}
                </DeckGL>
              </div>  
            </div>
            
          </div>
        </div>
      );
  }

}

export default withRouter(HeatMap);
